<template>
	<div class="help">
		帮助说明
		<nut-icon
			class-prefix="icon"
			font-class-name="iconfont"
			size="12"
			name="question-circle"
		>
		</nut-icon>
	</div>
</template>

<script>
export default {
	name: 'HelpTextTip',
};
</script>

<style lang="scss" scoped>
.help {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 15px 0;
	font-size: 12px;
	color: #8b8b8b;
}
</style>
